import React, { PropTypes } from 'react';
import Modal from "../../Modal";
import { observable, action, toJS } from "mobx/lib/mobx";
// import token from "../../../libs/token";
// import * as api from "../../../actions/api";
import { inject, observer } from "mobx-react/index";
import { FormActions, FormBody } from "../../Form";
import Form from "../../Form";
import ExportHeirTable from "./ExportHeirTable";
import ExportFilteredTable from "./ExportFilteredTable";
import { ExportFieldSelect } from "./ExportFieldSelect";
import { downloadCSV, downloadXlsx } from '../../DataDelivery/ReportingTemplate/downloader';

@inject('folderStore', 'stationStore', 'metaDataStore', 'uiStore')
@observer
export default class FolderStationExport extends React.Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = '/folder';
  title = 'Export Stations';

  @observable data = [];
  @observable forCheckBox = [];
  @observable savedPermissions = [];
  @observable searchFilter = '';
  @observable selectedTab = 'station';

  @observable availableFields = [
    { id: 'description', name: 'Description', key: 'description' },
    { id: 'elevation', name: 'Elevation', key: 'elevation' },
    { id: 'folder_id', name: 'Folder', key: 'folder_id' },
  ];
  @observable selectedFields = [
    { id: 'name', name: 'Name', key: 'name' },
    { id: 'identifier', name: 'Identifier', key: 'identifier' },
    { id: 'latitude', name: 'Latitude', key: 'latitude' },
    { id: 'longitude', name: 'Longitude', key: 'longitude' },
  ];


  componentWillMount() {
    const { metaDataStore } = this.props;
    if (!metaDataStore.items.length) metaDataStore.fetchItems();
    this.populate();
  }

  populate = () => {
    const { folderStore, stationStore } = this.props;
    if (!stationStore.items.length) {
      setTimeout(() => {
        this.populate();
      }, 500);
    } else {
      this.setCheckboxSelected(folderStore.items);
      this.flattenTableData(folderStore.items);
    }
  };

  @action setCheckboxSelected = (folders) => {
    this.forCheckBox = [];
    folders.map(folder => {
      this.forCheckBox.push({
        level: 1,
        id: folder.id,
        folderId: folder.id,
        selected: false,
        expanded: false
      });
      folder.stations.map(station => {
        this.forCheckBox.push({
          level: 2,
          id: station.id,
          stationId: station.id,
          selected: false,
          parentId: folder.id
        })
      })
    })
  };

  @action onChangeCheck = (index, selected = null) => {
    let selectedItem = this.data[index];
    this.forCheckBox[index].selected = selected !== null ? selected : !this.forCheckBox[index].selected;

    if (selectedItem.level == 1) {
      for (let i = index + 1; i < this.data.length; i++) {
        if (this.data[i].level == 1) {
          break;
        }
        this.forCheckBox[i].selected = selected !== null ? selected : this.forCheckBox[index].selected;
      }
    }
  };

  @action onChangeSearchText = e => this.searchFilter = e.target.value.toLowerCase();

  @action onChangeField = (dndLists) => {
    this.availableFields = dndLists[0].items;
    this.selectedFields = dndLists[1].items;
  };

  onClickExpandCollapse = (cb) => {
    if (cb.level === 1) this.forCheckBox.filter(x => x.folderId === cb.id)[0].expanded = !this.forCheckBox.filter(x => x.folderId === cb.id)[0].expanded;
  };

  flattenTableData = (folders) => {
    let data = [];
    folders.forEach(folder => {
      data.push({
        type: 'FOLDER',
        level: 1,
        key: data.length,
        id: folder.id,
        name: folder.name,
        selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
          value={this.forCheckBox.filter(cbitem => cbitem.folderId == folder.id)[0].selected}
          checked={this.forCheckBox.filter(cbitem => cbitem.folderId == folder.id)[0].selected} />,
        data: {
          id: folder.id,
          name: folder.name,
          selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
            value={this.forCheckBox.filter(cbitem => cbitem.folderId == folder.id)[0].selected}
            checked={this.forCheckBox.filter(cbitem => cbitem.folderId == folder.id)[0].selected} />
        }
      });
      folder.stations.forEach(station => {
        data.push({
          type: 'STATION',
          level: 2,
          key: data.length,
          id: station.id,
          name: station.name,
          selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
            value={this.forCheckBox.filter(cbitem => cbitem.stationId == station.id)[0].selected}
            checked={this.forCheckBox.filter(cbitem => cbitem.stationId == station.id)[0].selected} />,
          parent_id: folder.id,
          data: {
            id: station.id,
            name: station.name,
            selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
              value={this.forCheckBox.filter(cbitem => cbitem.stationId == station.id)[0].selected}
              checked={this.forCheckBox.filter(cbitem => cbitem.stationId == station.id)[0].selected} />
          }
        })
      })
    });
    this.data = data;
  };

  handleStationExportJSON = (e) => {
    e.preventDefault();
    const { notify, router } = this.context;
    const { stationStore } = this.props;

    let selectedStationIds = [];
    this.forCheckBox.map(cb => {
      if (cb.level == 2 && cb.selected) {
        selectedStationIds.push(cb.stationId)
      }
    });
    let selectedStations = stationStore.items.filter(item => selectedStationIds.indexOf(item.id) > -1).map(station => {
      let stationWithSelectedFields = {};
      this.selectedFields.forEach(field => {
        if (field.isMetaData) {
          let metaData = station.meta_data.find(item => item.id === field.id);
          Object.assign(stationWithSelectedFields, { [field.name]: metaData ? metaData.value : '' });
        } else Object.assign(stationWithSelectedFields, { [field.key]: station[field.key] });
      });
      return stationWithSelectedFields;
    });
    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    hiddenElement.href = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(selectedStations));
    hiddenElement.target = '_blank';
    hiddenElement.download = 'Stations.json';
    hiddenElement.click();
    router.push(this.slug);
  };

  handleStationExportCSV = async (e, { xlsx } = { xlsx: false }) => {
    e.preventDefault();
    const { notify, router } = this.context;
    const { folderStore, stationStore } = this.props;

    let selectedStationIds = [];
    this.forCheckBox.map(cb => {
      if (cb.level == 2 && cb.selected) {
        selectedStationIds.push(cb.stationId)
      }
    });
    let selectedStations = stationStore.items.filter(item => selectedStationIds.indexOf(item.id) > -1);


    let csv = `${this.selectedFields.map(field => field.name).join(',')}\n`;
    selectedStations.forEach(station => {
      let line = this.selectedFields.map(field => {
        if (!field.isMetaData && !station[field.key]) return '';
        else if (field.isMetaData) {
          let metaData = station.meta_data.find(item => item.id === field.id);
          return `${metaData ? metaData.value : ''}`
        } else {
          return `${station[field.key].toString().replace(/,/g, '-')}`;
        }
      }).join(',');
      csv += line + '\n'
    });

    await (xlsx ? downloadXlsx(csv, 'Stations') : downloadCSV(csv, 'Stations'));
    router.push(this.slug);
  };

  render() {
    const { metaDataStore, uiStore } = this.props;
    let availableFields = [
      ...this.availableFields,
      ...metaDataStore.items.map(item => ({
        id: item.id,
        name: item.name,
        isMetaData: true
      }))
    ];
    return (
      <Modal title={this.title} slug={this.slug}>
        <div className='TabBar TabBarRounded'>
          <ul>
            <li className={this.selectedTab === 'station' ? 'active' : ''} onClick={() => this.selectedTab = 'station'}><a>Stations</a></li>
            <li className={this.selectedTab === 'field' ? 'active' : ''} onClick={() => this.selectedTab = 'field'}><a>Fields</a></li>
          </ul>
        </div>
        <Form>
          <FormBody>
            {this.selectedTab === 'station' && <div>
              <div className='formInput'><input placeholder="Search" onChange={this.onChangeSearchText} style={{ margin: 10 }} /></div>
              <div style={{ height: '60vh', width: uiStore.mobileView ? 'calc(100vw - 110px)' : '50vw', overflowY: 'auto' }}>
                {this.searchFilter === '' ?
                  <ExportHeirTable data={this.data} forCheckBox={this.forCheckBox} onChangeCheck={this.onChangeCheck} onClickExpandCollapse={this.onClickExpandCollapse} /> :
                  <ExportFilteredTable data={this.data} searchFilter={this.searchFilter} forCheckBox={this.forCheckBox} onChangeCheck={this.onChangeCheck} />}
              </div>
            </div>}
            {this.selectedTab === 'field' && <div><ExportFieldSelect availableFields={availableFields} selectedFields={this.selectedFields} onChangeField={this.onChangeField} /></div>}
          </FormBody>
          <FormActions>
            <button className="button" onClick={this.handleStationExportJSON}>Export JSON</button>
            <button className="button" onClick={this.handleStationExportCSV}>Export CSV</button>
            <button className="button" onClick={e => this.handleStationExportCSV(e, { xlsx: true })}>Export Excel</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Folder/StationExport/FolderStationExport.js